/** قطاعات جديدة — تُدمج مع industries.ts (دمج عميق). */
export default {
  industries: {
    grocery: {
      name: 'متاجر البقالة والأغذية',
      tagline: 'مصمم لقطاع الأغذية',
      headline: 'تسليم بالنوافذ الزمنية ومسارات كثيفة لـ',
      headlineHighlight: 'التجزئة الطازجة',
      description:
        'تسليم في نفس اليوم ومجدول مع نوافذ زمنية وبدائل توجيه ومسارات ذكاء اصطناعي لكثافة عالية من المحطات دون فقدان ضبط سلسلة التبريد.',
      heroKeyPoints: [
        'نوافذ تسليم وسعة موثوقة',
        'الذكاء الاصطناعي يجمع الطلبات حسب المنطقة لتقليل الكيلومترات لكل تسليم',
        'تتبع بعلامتكم مع وقت وصول مباشر لكل سلة',
        'تسلسل حسب درجة الحرارة للطازج والمجمد',
      ],
      stats: [
        { value: '35٪', label: 'مزيد من التسليمات لكل جولة' },
        { value: '96٪', label: 'التزام بالنوافذ' },
        { value: '50٪', label: 'استفسارات أقل عن الطلب' },
      ],
      painPoints: [
        { title: 'النوافذ تنهار مع الحجم', description: 'الذروة تضغط على المسارات الثابتة — العميل يفوت النافذة ويذهب للمنافس.' },
        { title: 'البدائل تآكل الثقة', description: 'بدون تواصل واضح، الاستبدالات تولد مرتجعات وتقييمات سلبية.' },
        { title: 'سلسلة التبريد في آخر ميل', description: 'غرفة وبارد ومجمد في نفس الجولة تحتاج تسلسلاً لا حدساً.' },
      ],
      features: [
        { title: 'محرك النوافذ والسعة', description: 'نوافذ قابلة للحجز حسب الأسطول وأوقات الطريق وقطع التحضير.', tag: 'ذكاء اصطناعي' },
        { title: 'توجيه بأولوية الكثافة', description: 'يحسّن المحطات/الساعة ودقة النافذة لا المسافة فقط.', tag: 'ذكاء اصطناعي' },
        { title: 'رسائل البدائل', description: 'إشعار العميل قبل مغادرة السائق بقبول/رفض واضح.' },
        { title: 'تتبع مباشر بعلامتكم', description: 'صفحة متجر مع وقت وصول أدق وتعليمات التسليم.' },
        { title: 'تسلسل حسب الحرارة', description: 'ترتيب المحطات لتقليل الوقت خارج المركبة في البارد.' },
        { title: 'تطبيق السائق وإثبات التسليم', description: 'مسح عند الاستلام، صورة عند الباب، تحقق عمر عند الحاجة.' },
        { title: 'تحليلات العمليات', description: 'إشغال النافذة، تكلفة التسليم، خرائط الاستثناءات.' },
        { title: 'مزامنة نقطة البيع وOMS', description: 'ربط التجارة الإلكترونية وOMS والمتجر في خطة حية.', tag: undefined },
      ],
      useCases: [
        'سوبرماركت نفس اليوم',
        'هايبر بنوافذ',
        'مخزن مظلم / توصيل سريع',
        'سلاسل إقليمية',
        'جولات وجبات',
        'شاحنات إعادة تزويد B2B للمتجر',
      ],
    },
    'b2b-distribution': {
      name: 'توزيع B2B وتجارة جملة',
      tagline: 'مصمم للتوزيع',
      headline: 'برنامج تسليم من',
      headlineHighlight: 'المركز إلى العميل',
      description:
        'جولات متعددة المحطات إلى متاجر ومواقع بناء مع إثبات تسليم رقمي ونوافذ رصيف وتحليلات للعمليات والمالية دون جداول.',
      heroKeyPoints: [
        'مسارات متعددة مع بالتات وSKU',
        'إثبات تسليم رقمي بتوقيع وصورة وطابع زمني',
        'رؤية كالمرسل لحسابات رئيسية',
        'تقارير تكلفة التسليم وتكلفة الخدمة',
      ],
      stats: [
        { value: '22٪', label: 'انخفاض تكلفة التسليم' },
        { value: '99٪', label: 'التقاط إثبات التسليم' },
        { value: '2×', label: 'محطات لكل وردية' },
      ],
      painPoints: [
        { title: 'الإرسال في جداول', description: 'المخططون يرسلون PDF والسائقون يؤلفون — لا نسخة واحدة لليوم.' },
        { title: 'فوضى الرصيف والنافذة', description: 'فوات النافذة في المتجر أو الموقع تعني غرامات وفقد ثقة.' },
        { title: 'لا اقتصاد وحدة حقيقي', description: 'الوقود والوقت والمرتجعات غير مربوطة بربحية العميل أو الممر.' },
      ],
      features: [
        { title: 'توجيه حساس للحمولة', description: 'تسلسل حسب الوزن والحجم ونوع المحور.', tag: 'ذكاء اصطناعي' },
        { title: 'نوافذ مواعيد', description: 'وصول متجر/موقع مع هامش وتنبيهات التأخير.' },
        { title: 'إثبات تسليم مؤسسي', description: 'توقيع وصورة وتأكيد سطر بسطر.' },
        { title: 'بوابات الحساب', description: 'العملاء الكبار يرون الحالة والمستندات دون اتصال.' },
        { title: 'تحليلات الممرات', description: '€/كم، انتظار، دقة الموعد حسب المسار والمركز وطبقة العميل.' },
        { title: 'مسارات الاستثناء', description: 'الرفض والجزئي وإعادة التسليم مع مسؤول واضح.' },
        { title: 'ربط ERP وWMS', description: 'الطلبات وإثبات التسليم إلى نظام السجل.' },
        { title: 'برج المراقبة', description: 'خريطة واحدة: شاحنات نشطة، تأخير، استثناءات مفتوحة.' },
      ],
      useCases: [
        'إعادة توزيع خدمات الطعام',
        'موزعو المشروبات',
        'شاحنات إمدادات صناعية',
        'ورق وتعبئة',
        'خروج مركز إقليمي',
        'آخر ميل نقد وجملة',
      ],
    },
    'medical-supplies': {
      name: 'مستلزمات طبية ومختبرات',
      tagline: 'مصمم للوجستيات الطبية',
      headline: 'لوجستيات عينات وطقم ومستلزمات مع',
      headlineHighlight: 'نوافذ وإثبات',
      description:
        'استلام وتسليم للمختبرات والعيادات والأجهزة مع نوافذ صارمة وتتبع قابل للتدقيق وإثبات رقمي.',
      heroKeyPoints: [
        'تخطيط حرج للاستلام والتسليم',
        'قوائم سائق لسلامة الطقم والحرارة',
        'تتبع كامل للمراجعات',
        'إشعارات عميل مع وقت وصول مباشر',
      ],
      stats: [
        { value: '99.2٪', label: 'الالتزام بالنوافذ' },
        { value: '100٪', label: 'مسار رقمي' },
        { value: '30٪', label: 'أقل إعادة تسليم' },
      ],
      painPoints: [
        { title: 'SLA عينة المختبر', description: 'فوت النافذة يبطل الجولة — الهاتف لا يتوسع.' },
        { title: 'التدقيق والمسؤولية', description: 'بدون طابع زمني وتوقيع تتحول التحقيقات إلى لوم.' },
        { title: 'مواقع متعددة', description: 'مستشفيات وعيادات ومستودعات بقواعد ورصيف مختلف.' },
      ],
      features: [
        { title: 'توجيه بالنافذة', description: 'قيود صلبة ومرنة لجداول المختبر والعيادة.', tag: 'ذكاء اصطناعي' },
        { title: 'إثبات تسليم سلسلة حيازة', description: 'مسح، ختم، توقيع، صورة تدافع عن المراجعة.' },
        { title: 'حساسية البارد', description: 'وسم وتسلسل مقاطع حساسة بحد أقصى وقت عبور.' },
        { title: 'تنبيهات أصحاب المصلحة', description: 'المختبر والعيادة يُعلمان بالاستلام والتأخير والتسليم.' },
        { title: 'حلقات استلام وتسليم', description: 'تحسين العينات وإعادة التزويد في خطة واحدة.', tag: 'ذكاء اصطناعي' },
        { title: 'مسارات السائق', description: 'خطوات موجهة لسائقين جدد متوافقين.' },
        { title: 'تحليلات الامتثال', description: 'نسبة الاستلام في الوقت، أسباب الاستثناء، الانتظار حسب الموقع.' },
        { title: 'قرب LIS / EMR', description: 'تدفق الطلبات والحالة من أنظمة صحية شائعة.' },
      ],
      useCases: [
        'بري عينات تشخيص',
        'تسليم مخزون طبي جراحي',
        'تسليم رعاية منزلية',
        'لوجستيات أطقم تجارب سريرية',
        'مستلزمات أسنان وتصوير',
        'مقاطع بارد حيوي',
      ],
    },
    'field-service': {
      name: 'خدمة ميدانية',
      tagline: 'مصمم للميدان',
      headline: 'مواعيد وقطع وشاحنات في',
      headlineHighlight: 'إرسال واحد',
      description:
        'جداول يومية لتكييف ومرافق واتصالات وصناعة: مهارات وقطع وSLA ووقت وصول عميل متوافق مع CRM/FSM.',
      heroKeyPoints: [
        'مطابقة المهارات والشهادات',
        'قطع على الشاحنة لنجاح الزيارة الأولى',
        'أوقات وصول عميل تتحسن خلال اليوم',
        'صورة وتوقيع لكل أمر عمل',
      ],
      stats: [
        { value: '18٪', label: 'مزيد تدخلات/فني/يوم' },
        { value: '92٪', label: 'نجاح الزيارة الأولى' },
        { value: '40٪', label: 'أقل «أين أنتم؟»' },
      ],
      painPoints: [
        { title: 'فني خاطئ في الموقع', description: 'شهادة أو أداة ناقصة = زيارة ثانية.' },
        { title: 'القطعة ليست على الشاحنة', description: 'أمر العمل مجدول لكن المخزون غير مربوط بالمسار.' },
        { title: 'ضغط العميل', description: 'نوافذ ضيقة بدون وقت وصول مباشر = إلغاء وشكاوى.' },
      ],
      features: [
        { title: 'تعيين حسب المهارة', description: 'أمر عمل ↔ فني حسب المهارة والمنطقة والوردية.', tag: 'ذكاء اصطناعي' },
        { title: 'ربط القطع', description: 'حجز أو تجهيز على المسار.' },
        { title: 'أوقات وصول ديناميكية', description: 'تحديث للمالك/المرفق عند انزلاق اليوم.', tag: 'ذكاء اصطناعي' },
        { title: 'خريطة إرسال مباشرة', description: 'كل الفنيين، حالة أمر العمل، خطر التأخير.' },
        { title: 'إثبات تسليم أمر عمل', description: 'صور قبل/بعد، توقيعات، ملاحظات.' },
        { title: 'تحسين المواعيد', description: 'تجميع جغرافي داخل النوافذ الموعودة.' },
        { title: 'مقاييس الاستخدام', description: 'ساعات قابلة للفوترة، نسبة الطريق، SLA حسب الفريق.' },
        { title: 'جاهز CRM / FSM', description: 'مزامنة الوظائف والحالة والإغلاق.' },
      ],
      useCases: [
        'تركيب وصيانة تكييف',
        'صيانة مبانٍ',
        'فنيو اتصالات ميدانيون',
        'خدمة معدات صناعية',
        'تركيب منزل ذكي وأمن',
        'آفات وخدمات عقارية',
      ],
    },
    'building-supplies': {
      name: 'مواد بناء وأحمال ضخمة',
      tagline: 'مصمم للأحمال الكبيرة',
      headline: 'جولات ثقيلة وضخمة مع',
      headlineHighlight: 'نوافذ وإثبات',
      description:
        'خشب وأبواب وأكياس وتسليم مواقع بناء مع توجيه حسب المركبة ونوافذ وإثبات صور يصمد في النزاع.',
      heroKeyPoints: [
        'توجيه حسب فئة الشاحنة وأوقات خدمة واقعية',
        'جهة اتصال الموقع ورمز البوابة على المحطة',
        'صور أضرار ووضع التسليم',
        'تجميع طلبات حسب المنطقة وقواعد رافعة/عربة',
      ],
      stats: [
        { value: '25٪', label: 'أقل إعادة تسليم' },
        { value: '95٪', label: 'الالتزام بالنوافذ' },
        { value: '20٪', label: 'انخفاض وقود/طن' },
      ],
      painPoints: [
        { title: 'مركبة خاطئة للحمولة', description: 'شاحنة مسطحة مقابل فان = فشل وساعات إضافية.' },
        { title: 'وصول الموقع فوضوي', description: 'سائق بلا رمز أو جهة اتصال أو تعليمات تفريغ.' },
        { title: 'نزاعات الأضرار', description: 'بدون صور، «كان كذلك مسبقاً» تأكل الهامش.' },
      ],
      features: [
        { title: 'ملفات مركبة', description: 'سعة وارتفاع وزمن تفريغ حسب عائلة SKU.', tag: 'ذكاء اصطناعي' },
        { title: 'نوافذ الموقع', description: 'صباح فقط أو نوافذ رافعة مع هامش.' },
        { title: 'تعليمات الموقع', description: 'جهات اتصال، رموز، مخاطر ظاهرة في التطبيق.' },
        { title: 'إثبات تفريغ', description: 'سلسلة صور + توقيع مربوط بالسطر والطابع الزمني.' },
        { title: 'مسارات ثقيلة متعددة المحطات', description: 'تسلسل لأقل إعادة تحميل وانعطافات.', tag: 'ذكاء اصطناعي' },
        { title: 'مسارات استثناء', description: 'رفض، جزئي، إعادة تسليم مع تنبيه الإرسال.' },
        { title: 'تحليلات طن-ميل', description: 'تكلفة ووقت لكل طن حسب الوكالة ونوع العميل.' },
        { title: 'مزامنة طلبات ERP', description: 'سحب التسليمات المفتوحة، دفع الحالة.' },
      ],
      useCases: [
        'تجارة خشب ومواد',
        'أبواب ونوافذ',
        'أسمنت وركام معبأ',
        'سقف وعزل',
        'تسليم تأجير معدات',
        'جولات مكتب محترفين للحرفيين',
      ],
    },
    'automotive-parts': {
      name: 'قطع غيار سيارات',
      tagline: 'مصمم للقطع',
      headline: 'قطع نفس اليوم وخط الوكالة مع',
      headlineHighlight: 'توجيه أولوية',
      description:
        'طوارئ الوكالة والورش والتجزئة مع أولويات وحدود زمنية وتتبع لـVOR ووعود الخدمة.',
      heroKeyPoints: [
        'أولوية VOR والعاجل في المحلل',
        'التزامات زمنية للورشة والوكالة',
        'مسح تحقق استلام وتسليم',
        'لوح بعد الدوام ويوم السبت',
      ],
      stats: [
        { value: '45 د', label: 'متوسط الساق العاجل' },
        { value: '98٪', label: 'الوكالة في الوقت' },
        { value: '15٪', label: 'كم موفرة' },
      ],
      painPoints: [
        { title: 'ذعر VOR', description: 'كل طوارئ تكسر الخطة والمخطط يعيد يدوياً.' },
        { title: 'قطعة خاطئة على الرصيف', description: 'الخطأ يظهر في الوكالة — الثقة تهبط.' },
        { title: 'انزلاق الحد الزمني', description: '«قبل الظهر» يتدهور إذا الصباح غير شفاف.' },
      ],
      features: [
        { title: 'مستويات أولوية', description: 'VOR، نفس اليوم، قياسي مع أوزان المحلل.', tag: 'ذكاء اصطناعي' },
        { title: 'مسح تحقق', description: 'SKU وموقع الاستلام، إعادة مسح عند الوكالة.' },
        { title: 'تحسين داخل المدينة', description: 'حلقات وكالة كثيفة، أقل فراغ.', tag: 'ذكاء اصطناعي' },
        { title: 'تواصل الوكالة', description: 'رسائل وبريد مع وقت وصول مباشر وسبب التأخير.' },
        { title: 'تتبع بعلامة', description: 'صفحات OEM أو موزع لحسابات مميزة.' },
        { title: 'إثبات استثناء', description: 'رفض أو جزئي موثق بالصورة.' },
        { title: 'لوحات SLA', description: 'الدقة حسب طبقة الوكالة وعائلة SKU والسائق.' },
        { title: 'خطافات DMS / IMS', description: 'طلبات قطع وإقرارات إلى المخزون.' },
      ],
      useCases: [
        'برامج ليل OEM',
        'تزويد ورش مستقلة',
        'شاحنات إطارات كبيرة',
        'إكسسوارات نفس اليوم',
        'طوارئ هيكل',
        'مستودعات أسطول',
      ],
    },
    'contract-logistics': {
      name: 'لوجستيات تعاقدية و3PL',
      tagline: 'مصمم لـ3PL',
      headline: 'لوجستيات متعددة المرسلين مع',
      headlineHighlight: 'بوابات وSLA',
      description:
        'نقل مخصص ومشترك لعدة مرسلين مع رؤية معزولة وتتبع كالناقل وتحليلات موثوقة لعملائكم.',
      heroKeyPoints: [
        'تتبع بعلامة وSLA لكل مرسل',
        'تخطيط مراكز وخط جذع',
        'مطالبات واستثناءات قابلة للتدقيق',
        'هامش وتكلفة خدمة لكل حساب',
      ],
      stats: [
        { value: '30٪', label: 'أقل إدارة حالة' },
        { value: '99٪', label: 'اعتماد التتبع' },
        { value: '2×', label: 'إدماج أسرع' },
      ],
      painPoints: [
        { title: 'إرهاق الرؤية', description: 'العمليات تجيب «أين الشحنة؟» باستمرار.' },
        { title: 'SLA غامض', description: 'العقد يعد مستويات الأداة لا تقيسها.' },
        { title: 'عمى الهامش', description: 'حجم مربح، أموال ضائعة على ممرات غير مُنمذجة.' },
      ],
      features: [
        { title: 'رؤية متعددة المستأجرين', description: 'كل مرسل يرى شحنته فقط، علامتهم أو علامتكم.' },
        { title: 'توجيه الشبكة', description: 'مراكز، خط جذع، آخر ميل مع صلاحيات حسب الدور.', tag: 'ذكاء اصطناعي' },
        { title: 'مراقبة SLA', description: 'تنبيهات قبل الكسر مع إجراءات استرداد.' },
        { title: 'أحداث قابلة للتدقيق', description: 'حالة، إثبات تسليم، تواصل بطابع زمني لكل مقطع.' },
        { title: 'اقتصاد لكل حساب', description: 'إيراد، تكلفة، هامش لكل عميل وممر.' },
        { title: 'خدمة ذاتية للمرسل', description: 'حجز، مستندات، خريطة مباشرة دون بريد ذهاب وإياب.' },
        { title: 'بطاقات تنفيذية', description: 'الدقة، تكلفة الطلب، الجودة لكل عقد كبير.' },
        { title: 'API أولاً', description: 'حقن الطلبات والأحداث إلى TMS وWMS ونظم المرسل.' },
      ],
      useCases: [
        'نقل إقليمي تعاقدي',
        '3PL تنفيذ تجارة إلكترونية',
        'أسطول مخصص صناعي',
        'مقاطع 3PL بارد',
        'تجميع وارد تجزئة',
        'آخر ميل علامة بيضاء',
      ],
    },
  },
};
